<template>
  <div class="o-initial-setup">
    <MoleculeInitialSetup/>
  </div>
</template>

<script>
export default {
  name: 'OrganismInitialSetup',

  components: {
    MoleculeInitialSetup: () => import('@/components/molecules/MoleculeInitialSetup')
  }
}
</script>
